import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { ThemeProvider } from "./components/theme-provider";
import { BreadcrumbsProvider } from "./contexts/BreadcrumbsContext";
import { getQueryClient } from "./utils/queryClient";
import { PostHogProvider } from "posthog-js/react";
import { PostHogConfig } from "posthog-js";
import { RouteErrorComponent } from "@quake/shared-ui/components/ui/error-boundary";

const options: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-05-24",
  before_send: (event) => {
    if (import.meta.env.PROD) {
      return event;
    }
    return null;
  },
};

export const createDashboardRouter = () => createRouter({ routeTree, defaultErrorComponent: RouteErrorComponent });
export const router = createDashboardRouter();

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

type AppProps = {
  routerInstance?: typeof router;
};

export function App({ routerInstance = router }: AppProps) {
  const queryClient = getQueryClient();
  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
        <QueryClientProvider client={queryClient}>
          <BreadcrumbsProvider>
            <RouterProvider router={routerInstance} />
          </BreadcrumbsProvider>
        </QueryClientProvider>
      </PostHogProvider>
    </ThemeProvider>
  );
}
